import { Experience } from '@/types'
import { Star } from 'lucide-react'
import React from 'react'

const ExperienceRate = ({ experience }: { experience: Experience }) => {
  return null

  if (experience.rateCount === 0) {
    return null
  }

  return (
    <div className="flex items-center">
      <Star fill="#ffc32a" size={18} strokeWidth={0} />
      <span className="text-sm">{experience.rate}/5</span>
    </div>
  )
}

export default ExperienceRate
